import { cva } from 'class-variance-authority';
const root = cva([
    'md:hidden flex py-[10px] px-150 w-auto justify-between z-50 items-center gap-200 relative text-primary',
]);
export const mobileNavbarStyles = {
    root,
};
